// View registry — populates `window.adminViews.*` from each view module's
// default export.
//
// This module MUST be evaluated before `admin.js`. admin.js runs its boot
// sequence (the view `mount()` calls around its top level + the session
// `gate()` that fires the shift-activation prompt) at module-evaluation
// time, and it reads `window.adminViews.*` synchronously. ES module bodies
// run only after all of a module's static imports finish, so doing these
// assignments in `main.js`'s body — below the static `import '../admin.js'`
// — was too late: admin.js had already mounted before the views existed,
// silently skipping `adminViews.shiftManagement.mount()`. That left the
// shift dialog DOM unresolved, so `ensureShiftPrompt()` bailed at its
// `if (!shiftSetupDlg)` guard and the activation popup never opened.
//
// By importing this file (a side-effect import) ahead of admin.js, the
// registry is fully populated by the time admin.js boots.
import accessPointsView from '../js/views/access-points.js';
import aiPromptsView from '../js/views/ai-prompts.js';
import campaignsView from '../js/views/campaigns.js';
import channelSettingsView from '../js/views/channel-settings.js';
import crmView from '../js/views/crm.js';
import crmConfigView from '../js/views/crm-config.js';
import crmInstallationsView from '../js/views/crm-installations.js';
import crmReconciliationView from '../js/views/crm-reconciliation.js';
import crmRetentionView from '../js/views/crm-retention.js';
import crmQuotesView from '../js/views/crm-quotes.js';
import invoicingReviewView from '../js/views/invoicing-review.js';
import invoicingCalendarView from '../js/views/invoicing-calendar.js';
import invoicingTaxationView from '../js/views/invoicing-taxation.js';
import invoicingReviewsView from '../js/views/invoicing-reviews.js';
import essPortalView from '../js/views/ess-portal.js';
import revenueComplianceView from '../js/views/revenue-compliance.js';
import customersView from '../js/views/customers.js';
import dailyStatusView from '../js/views/daily-status.js';
import distributorsView from '../js/views/distributors.js';
import duplicateMessagesView from '../js/views/duplicate-messages.js';
import emailOutboxView from '../js/views/email-outbox.js';
import hrView from '../js/views/hr.js';
import hrReportView from '../js/views/hr-report.js';
import inventoryView from '../js/views/inventory.js';
import infraView from '../js/views/infra.js';
import nocView from '../js/views/noc.js';
import logsView from '../js/views/logs.js';
import messageTemplatesView from '../js/views/message-templates.js';
import mobileCustomersView from '../js/views/mobile-customers.js';
import productsView from '../js/views/products.js';
import reportsView from '../js/views/reports.js';
import securityView from '../js/views/security.js';
import sessionsView from '../js/views/sessions.js';
import shiftManagementView from '../js/views/shift-management.js';
import systemHealthView from '../js/views/system-health.js';
import techniciansView from '../js/views/technicians.js';
import usersView from '../js/views/users.js';
import whatsappCsatView from '../js/views/whatsapp-csat.js';

window.adminViews = window.adminViews || {};
window.adminViews.accessPoints = accessPointsView;
window.adminViews.aiPrompts = aiPromptsView;
window.adminViews.campaigns = campaignsView;
window.adminViews.channelSettings = channelSettingsView;
window.adminViews.crm = crmView;
window.adminViews.crmConfig = crmConfigView;
window.adminViews.crmInstallations = crmInstallationsView;
window.adminViews.crmReconciliation = crmReconciliationView;
window.adminViews.crmRetention = crmRetentionView;
window.adminViews.crmQuotes = crmQuotesView;
window.adminViews.invoicingReview = invoicingReviewView;
window.adminViews.invoicingCalendar = invoicingCalendarView;
window.adminViews.invoicingTaxation = invoicingTaxationView;
window.adminViews.invoicingReviews = invoicingReviewsView;
window.adminViews.essPortal = essPortalView;
window.adminViews.revenueCompliance = revenueComplianceView;
window.adminViews.hrReport = hrReportView;
window.adminViews.customers = customersView;
window.adminViews.dailyStatus = dailyStatusView;
window.adminViews.distributors = distributorsView;
window.adminViews.duplicateMessages = duplicateMessagesView;
window.adminViews.emailOutbox = emailOutboxView;
window.adminViews.hr = hrView;
window.adminViews.inventory = inventoryView;
window.adminViews.infra = infraView;
window.adminViews.noc = nocView;
window.adminViews.logs = logsView;
window.adminViews.messageTemplates = messageTemplatesView;
window.adminViews.mobileCustomers = mobileCustomersView;
window.adminViews.products = productsView;
window.adminViews.reports = reportsView;
window.adminViews.security = securityView;
window.adminViews.sessions = sessionsView;
window.adminViews.shiftManagement = shiftManagementView;
window.adminViews.systemHealth = systemHealthView;
window.adminViews.technicians = techniciansView;
window.adminViews.users = usersView;
window.adminViews.whatsappCsat = whatsappCsatView;
